import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {MatNativeDateModule, MatRippleModule} from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import {
    MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatFormFieldDefaultOptions,
    MatFormFieldModule
} from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
    NbAlertModule,
    NbCardModule,
    NbDatepickerModule,
    NbIconModule,
    NbInputModule,
    NbLayoutModule,
    NbPopoverModule,
    NbSpinnerModule, NbTabsetModule
} from "@nebular/theme";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { ConfirmationDialogComponent } from "./components/confirmation-dialog/confirmation-dialog.component";
import { BadgeComponent } from "./components/badge/badge.component";
import { ImagePreloaderDirective } from "./directives/image-preloader.directive";
import { CountriesFilterComponent } from "./components/inputs/countries-filter/countries-filter.component";
import { SelectHttpFilterComponent } from "./components/inputs/select-http-filter/select-http-filter.component";
import { DateIntervalFilterComponent } from "./components/inputs/date-interval-filter/date-interval-filter.component";
import { SelectInputComponent } from "./components/inputs/select-input/select-input.component";
import { SelectFilterComponent } from "./components/inputs/select-filter/select-filter.component";
import { SearchBarComponent } from "./components/inputs/search-bar/search-bar.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { AlertErrorComponent } from "./components/alert-error/alert-error.component";
import { ImageUploadComponent } from "./components/image-upload/image-upload.component";
import { DragDropDirective } from "./directives/drag-drop.directive";
import { BackButtonDirective } from "./directives/back-button.directive";
import { TableFiltersComponent } from "./components/table-filters/table-filters.component";
import { TextHumanizePipe } from "./pipes/text-humanize.pipe";
import { ErrorComponent } from "./components/inputs/error/error.component";
import { ButtonSpinnerDirective } from "./directives/button-spinner.directive";
import { AvatarComponent } from "./components/avatar/avatar.component";
import { SelectHttpInputComponent } from "./components/inputs/select-http-input/select-http-input.component";
import {BoostCategoryPipe} from "./pipes/boost-category.pipe";
import {AgmCoreModule} from "@agm/core";
import {MatDatepickerModule} from "@angular/material/datepicker";
import { environment } from "../../environments/environment";
import { ReviewTableComponent } from './components/review-table/review-table.component';
import { BookingLiteTableComponent } from './components/booking-lite-table/booking-lite-table.component';
import {MatMomentDateModule} from "@angular/material-moment-adapter";
import { DialogAddNoteComponent } from './components/dialog-add-note/dialog-add-note.component';
import { Nl2brPipe } from './pipes/nl2br.pipe';
import { DialogPushNotificationComponent } from './components/dialog-push-notification/dialog-push-notification.component';
import { PotentialDriverStatusesPipe } from './pipes/potential-driver-statuses.pipe';
import { TableInvoiceComponent } from './components/table-invoice/table-invoice.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

const nebularModules = [
    NbEvaIconsModule,
    NbIconModule,
    NbCardModule,
    NbLayoutModule,
    NbPopoverModule,
    NbDatepickerModule,
    NbSpinnerModule,
    NbAlertModule,
    NbInputModule,
    NbTabsetModule
];

const materialModules = [
    MatButtonModule,
    MatRippleModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatMomentDateModule
];

const usedModules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpClientModule,
    FlexLayoutModule,
    NgSelectModule,
    NgxChartsModule,
    ...nebularModules,
    ...materialModules
];

const componentsList = [
    ImagePreloaderDirective,
    BackButtonDirective,
    ButtonSpinnerDirective,
    DragDropDirective,
    CountriesFilterComponent,
    DateIntervalFilterComponent,
    SelectHttpFilterComponent,
    SelectInputComponent,
    SelectFilterComponent,
    SelectHttpInputComponent,
    SearchBarComponent,
    ImageUploadComponent,
    TableFiltersComponent,
    BadgeComponent,
    ConfirmationDialogComponent,
    AlertErrorComponent,
    TableFiltersComponent,
    ErrorComponent,
    AvatarComponent,
    TextHumanizePipe,
    BoostCategoryPipe
];

const appearance: MatFormFieldDefaultOptions = {
    appearance: "fill"
};

@NgModule({
    declarations: [...componentsList, AvatarComponent, ReviewTableComponent, BookingLiteTableComponent, DialogAddNoteComponent, Nl2brPipe, DialogPushNotificationComponent, PotentialDriverStatusesPipe, TableInvoiceComponent],
    imports: [
        ...usedModules,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey,
        })
    ],
    exports: [
        ...usedModules,
        ...componentsList,
        AgmCoreModule,
        ReviewTableComponent,
        BookingLiteTableComponent,
        Nl2brPipe,
        PotentialDriverStatusesPipe,
        TableInvoiceComponent
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: appearance
        }
    ]
})
export class SharedModule {}
